import { Component, Input, OnInit } from "@angular/core";

type LoaderType = "bar" | "circle";
@Component({
    selector: "mobi-office-lib-loader",
    templateUrl: "./loader.component.html",
    styleUrls: ["./loader.component.scss"],
    standalone: false
})
export class LoaderComponent {
  @Input() loader: boolean = true;
  @Input() loaderType: LoaderType = "bar";
}
